import { ConsultantSetupModal } from "../../onboarding/shared/consultant-setup-modal.tsx";
import { useEffect, useState } from "react";

import { Modal } from "../../../ui/modal/modal.tsx";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../../ui/tabs/tabs.tsx";
import type { HrSetupEmployeeRow } from "../schemas/hr-setup-employee.schema.ts";
import { HrPersonalDetailTab } from "../tabs/hr-personal-detail-tab.tsx";
import { HrContactDetailTab } from "../tabs/hr-contact-detail-tab.tsx";
import { HrApproveTab } from "../tabs/hr-approve-tab.tsx";

import styles from "./hr-approval-modal.module.css";

const TAB_PERSONAL = "personal";
const TAB_CONTACT = "contact";
const TAB_APPROVE = "approve";

export type HrApprovalModalProps = {
  open: boolean;
  onClose: () => void;
  employee: HrSetupEmployeeRow | null;
  onSuccess: () => void;
};

export function HrApprovalModal({ open, onClose, employee, onSuccess }: HrApprovalModalProps) {
  const [activeTab, setActiveTab] = useState<string>(TAB_PERSONAL);

  useEffect(() => {
    if (!open) {
      setActiveTab(TAB_PERSONAL);
    }
  }, [open]);

  if (employee == null) return null;
  if (employee.employeeType === "CONSULTANT" || employee.consultantId != null) {
    return <ConsultantSetupModal key={String(employee.consultantId)} open={open} employee={employee} stage="HR" onClose={onClose} onSuccess={onSuccess} />;
  }

  const usesUsIdentityFields = employee.aadharNum == null;

  const handleApproveSuccess = () => {
    onSuccess();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title="Employee Setup" size="xl">
      <Tabs value={activeTab} onValueChange={setActiveTab} className={styles.tabsRoot}>
        <TabsList className={styles.tabsList}>
          <TabsTrigger value={TAB_PERSONAL} className={styles.tabTrigger}>
            Personal
          </TabsTrigger>
          <TabsTrigger value={TAB_CONTACT} className={styles.tabTrigger}>
            Contact
          </TabsTrigger>
          <TabsTrigger value={TAB_APPROVE} className={styles.tabTrigger}>
            Office Details
          </TabsTrigger>
        </TabsList>

        <TabsContent value={TAB_PERSONAL} className={styles.tabPanel}>
          <HrPersonalDetailTab
            key={`personal-${String(employee.id)}`}
            employee={employee}
            usesUsIdentityFields={usesUsIdentityFields}
            onSuccess={onSuccess}
          />
        </TabsContent>

        <TabsContent value={TAB_CONTACT} className={styles.tabPanel}>
          <HrContactDetailTab
            key={`contact-${String(employee.id)}`}
            employee={employee}
            onSuccess={onSuccess}
          />
        </TabsContent>

        <TabsContent value={TAB_APPROVE} className={styles.tabPanel}>
          <HrApproveTab
            key={`approve-${String(employee.id)}`}
            employee={employee}
            usesUsIdentityFields={usesUsIdentityFields}
            onCancel={onClose}
            onSuccess={handleApproveSuccess}
          />
        </TabsContent>
      </Tabs>
    </Modal>
  );
}
